import React, { Fragment, memo, FC } from "react";
import Skeleton from '@pedidosya/web-fenix/atoms/Skeleton';
import { Space } from '@components/Space/Space';
import {
  SubContainerSkeleton,
  MrSkeleton,
  WrapSkeletons,
  RowSkeleton, ContainerSkeleton, ShopCardContainer, DescriptionShopCard, SwiperContainer, ColumnSkeleton, ContainerSkeletonFood
} from './SkeletonFoodDesktopStyled';

interface IFoodSkeletonDesktop {
  index: number;
}

export const FoodSkeletonDesktop: FC<IFoodSkeletonDesktop> = memo(({ index }) => (
  <Fragment key={index}>
    <ContainerSkeleton data-testid='skeleton-food'>
      <SubContainerSkeleton>
        <MrSkeleton>
          <Skeleton
            height="12"
            shape="square"
            width="12"
          />
        </MrSkeleton>
        <WrapSkeletons>
          <Skeleton
            height="4"
            shape="square"
            width="71.75"
          />
          <Space mb={4} />
            <Skeleton
              height="4"
              shape="square"
              width="35.5"
            />
        </WrapSkeletons>
      </SubContainerSkeleton>
      <SwiperContainer>
        <RowSkeleton>
          {Array.from({ length: 6 }).map(() => (
            <ShopCardContainer key={index}>
              <Skeleton
                height="29.25"
                shape="square"
                width="42"
              />
              <DescriptionShopCard>
                <Space mb={12} />
                <Skeleton
                  height="4"
                  shape="square"
                  width="36"
                />
                <Space mb={16} />
                <ColumnSkeleton>
                  <Skeleton
                    height="4"
                    shape="square"
                    width="11.5"
                  />
                  <Space mt={4} />
                  <Skeleton
                    height="4"
                    shape="square"
                    width="18"
                  />
                </ColumnSkeleton>
              </DescriptionShopCard>
            </ShopCardContainer>
          ))}
        </RowSkeleton>
      </SwiperContainer>
    </ContainerSkeleton>
  </Fragment>
));

interface ISkeletonList {
  count: number;
}

const SkeletonList: React.FC<ISkeletonList> = ({ count }) => {
  const skeletons = Array.from({ length: count }, (_, i) => i);

  return (
    <ContainerSkeletonFood>
      {skeletons.map((skeleton, index) => (
        <FoodSkeletonDesktop index={index} key={skeleton} />
      ))}
    </ContainerSkeletonFood>
  );
};

export default memo(SkeletonList);